<template>
<div style="height:100%">
    <div class="assets-details-in-metadata-manager">
        <div v-if="mediaLogsArr.length == 0" style="font-size: 20px; margin-top: 8%; color: #686868;text-align:center">
              No Data Found
            </div>
                  <ul v-else>
                    <li v-if="['file','page'].includes(fileInfo.file_type) && Object.keys(fileInfo).includes('file_name') &&
                      !['undefined',null].includes(fileInfo.file_name) &&  fileInfo.file_name.length > 0">
                        <div class="key-style">{{$t('Filename')}}</div>
                        <div class="value-style">{{fileInfo.file_name}}</div>
                    </li>
                    <li v-else-if="Object.keys(fileInfo).includes('slug_name') &&
                      !['undefined',null].includes(fileInfo.slug_name) &&  fileInfo.slug_name.length > 0">
                        <div class="key-style">{{$t('Slug')}}</div>
                        <div class="value-style">{{fileInfo.slug_name}}</div>
                    </li>
                    <li v-if="barcodeInfoFromStartup.enable_reference_id_workflow && Object.keys(fileInfo).includes('reference_id') &&
                      !['undefined',null].includes(fileInfo.reference_id) &&  fileInfo.reference_id.length > 0">
                        <div class="key-style">{{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}</div>
                        <div class="value-style">{{fileInfo.reference_id}}</div>
                    </li>
                    <li v-if="Object.keys(fileInfo).includes('size') &&
                        !['undefined',null].includes(fileInfo.size) &&  fileInfo.size > 0">
                        <div class="key-style">{{$t('Size')}}</div>
                        <div class="value-style">{{humaniseSize(fileInfo.size)}} ({{fileInfo.size}} bytes)</div>
                    </li>
                    <li v-if="'mime_type' in fileInfo && fileInfo.mime_type && (fileInfo.mime_type.startsWith('video') || fileInfo.mime_type.startsWith('audio')) &&
                      'duration' in fileInfo && fileInfo.duration">
                        <div class="key-style">{{$t('Duration')}}</div>
                        <div class="value-style">{{getHumanReadableDuration(fileInfo.duration)}}</div>
                    </li>
                    <template v-for="stageInfo in mediaLogsArr">
                        <li :key="stageInfo._id">
                            <template>
                                 <div class="value-style">
                                   <div  class="wrap-file-info" style="width:100%">
                                       <div v-if="Object.keys(stageInfo).includes('stage_name') &&
                                           !['undefined',null].includes(stageInfo.stage_name) &&  stageInfo.stage_name.length > 0" style="display:flex">
                                         <div class="key-style mr-2">{{$t('Stage Name')}}</div>
                                         <div class="value-style ml-0">{{stageInfo.stage_name}}</div>
                                       </div>
                                       <div v-if="(Object.keys(stageInfo).includes('action') &&
                                           !['undefined',null].includes(stageInfo.action) &&  stageInfo.action.length > 0)"  style="display:flex">
                                         <div class="key-style mr-2">{{$t('Action')}}</div>
                                         <div class="value-style ml-0">{{stageInfo.action}}</div>
                                       </div>
                                       <div v-if="(Object.keys(stageInfo).includes('username') &&
                                       !['undefined',null].includes(stageInfo.username) &&  stageInfo.username.length > 0)"  style="display:flex">
                                            <div class="key-style mr-2">{{$t('Username')}}</div>
                                            <div class="value-style ml-0">{{stageInfo.username}}</div>
                                        </div>
                                       <div v-if="(Object.keys(stageInfo).includes('stage_entry_time') &&
                                           !['undefined',null].includes(stageInfo.stage_entry_time) &&  stageInfo.stage_entry_time.length > 0)"  style="display:flex">
                                         <div class="key-style mr-2">{{$t('Stage entry time')}}</div>
                                         <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(stageInfo.stage_entry_time)}}</div>
                                       </div>
                                       <div v-if="(Object.keys(stageInfo).includes('stage_exit_time') &&
                                       !['undefined',null].includes(stageInfo.stage_exit_time) &&  stageInfo.stage_exit_time.length > 0)"  style="display:flex">
                                            <div class="key-style mr-2">{{$t('Stage exit time')}}</div>
                                            <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(stageInfo.stage_exit_time)}}</div>
                                        </div>
                                        <div v-if="(Object.keys(stageInfo).includes('action_datetime') &&
                                            !['undefined',null].includes(stageInfo.action_datetime) &&  stageInfo.action_datetime.length > 0)"  style="display:flex">
                                          <div class="key-style mr-2">{{$t('Action date time')}}</div>
                                          <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(stageInfo.action_datetime)}}</div>
                                        </div>
                                        <div v-if="(Object.keys(stageInfo).includes('summary') &&
                                        !['undefined',null].includes(stageInfo.summary) &&  stageInfo.summary.length > 0)"  style="display:flex">
                                         <div class="key-style mr-2">{{$t('Summary')}}</div>
                                         <div class="value-style ml-0">{{stageInfo.summary}}</div>
                                     </div>
                                   </div>
                                 </div>
                             </template>
                         </li>
                    </template>
                  </ul>
        </div>

</div>
</template>


<script>
import {mapActions} from "vuex";
import Utils from "../../components.utils.js" ;

export default {
    props:["fileInfo"],
    data(){
        return{
            mediaLogsArr:[]
        }
    },
    methods:{
        humaniseSize(bytes){
            let data = Utils.humanizeSize(bytes)
            return `${data["value"]} ${data["unit"]}`
        },
        getHumanReadableDuration(duration){
            return Utils.getDurationInSeconds(duration, true)
        },
      ...mapActions("mediaPipeline", ["getMediaLogFromServer"]),
    },
    created() {
        let payload = {"_id":this.fileInfo.asset_id}
        this.getMediaLogFromServer(payload).then((data) => {
          this.mediaLogsArr = data.media_pipeline_log;
        })
    },
    computed:{
        barcodeInfoFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
    }
}
</script>

<style lang="scss" scoped>

$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$panel-heading-font-size:18px;
$secondary-border-color: 1px solid #2b2b2b;

.each-history-main-wrapper{
    border-bottom: 1px solid #2b2b2b;
    padding: 8px 5px;
    position: relative !important;
    .summary-div{
      display: inline-flex;
      align-items: center;
      padding:0px 10px 10px 10px;
      .summary-data-div{
        font-size: 16px;
      }
      .date-lael{
        color: $secondary-text-color;
        margin-inline-start:10px;
        font-size:12px;
      }
    }
    .detailed-information-wrapper{
      padding:0px 10px 10px 10px;
      color:#c6c6c6;
      pre{
        color:#c6c6c6 !important;
        font-family: "Roboto", Arial, sans-serif !important;
      }
    }
  } 

  ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:20%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 95%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}
  

.wrap-file-info{
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 0px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
  }

  .assets-details-in-metadata-manager{
    height:90%;
    overflow:auto
  }

  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }


</style>
